import { ColProps } from 'antd';
import { UseLabelCol } from './type';

export const useLabelCol: UseLabelCol = ({ mode, labelCol, isMobile }) => {
  const resultLabelCol: { showLabelCol: ColProps } = {
    showLabelCol: {
      span: 8,
    },
  };
  if (isMobile) {
    return resultLabelCol;
  }
  resultLabelCol.showLabelCol = mode === 'edit' ? { span: 24 } : labelCol;
  return resultLabelCol;
};
